import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { adminPanelConfigOptionType, adminPanelOptionConfigRegistryType, adminPanelOptionRegistryKeyValue } from '../../components/adminPanelLayout/adminPanelTypes';
import { ChannelkartNetworkGet } from '../../services/networkService';
import RenderSvg from '../../components/renderSvg/RenderSvg';
import './AdminPanel.css';
import { Loader } from '../../components/loader/Loader';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';
import { convertToAdminPanelOptions, getMetaDataConfig, getPortalRoleConfig } from '../../services/uiConfigService';
import { featureType } from '../manageRole/ManageRoleRegistry';
import store from '../../stateManagement/store';
import { eventEnum, logEvent } from '../../services/eventsService/eventService';
import { isProductionMovementCompleted, isStandardLob, showProductionMovementOption, updateOnboardingStatus, updateProductionMovement } from '../../services/userOnboardService/userOnboardService';
import ProductionMovementConfirmationPopup from '../salescodeStudio/finalApp/popups/productionMovementConfirmationPopup';
import { setMdmCurrentStep } from '../../stateManagement/actions/mdmDashboard';
const CUR_COMPONENT = "Admin Panel"
async function getAdminPanelOptionsConfig(){
    const response = await ChannelkartNetworkGet('/metadata/clientconfig');
    const adminPanelConfigObj = response.data.features.find((Obj: { domainType: string }) => {
        return Obj.domainType === 'admin_Panel_Options_Configuration'
    })
    return adminPanelConfigObj?.domainValues?.[0]?.value || [];
}
export const adminPanelOptionConfigRegistry: adminPanelOptionConfigRegistryType = {
    // manageBanner: {
    //     label: "Manage Banner",
    //     description: "Create, Update Delete and manage banner",
    //     svgName: "manageBannerIcon",
    //     route: "/dashboard/manageBanner",
    //     color: "#0ABBD5"
    // },
    // smartTrigger: {
    //     label: "Smart Triggers",
    //     description: "Create Smart Triggers",
    //     svgName: "smartTriggerIcon",
    //     route: "/dashboard/smartTrigger",
    //     color: "#52b894"
    // },
    support: {
        label: "Support",
        description: "Customer service and ticket management",
        svgName: "supportIcon",
        route: "/dashboard/support",
        color: "#df263d"
    },
    notification: {
        label: "Notification",
        description: "Create Notifications",
        svgName: "notificationsIcon",
        route: "/dashboard/notification",
        color: "#fad11d"
    },
    fileUpload: {
        label: "BlobKey Generator",
        description: "Get blob key of uploaded files",
        svgName: "fileUploadIcon",
        route: "/dashboard/blobKeyGenerator",
        color: "#52b894"
    },
    // manageBasket: {
    //     label: "Manage Basket",
    //     description: "Create, Update Delete and manage basket",
    //     svgName: "manageBasketIcon",
    //     route: "/dashboard/manageBasket",
    //     color: "#0ABBD5"
    // },
    // manageBucket: {
    //     label: "Manage Bucket",
    //     description: "Create, Update Delete and manage the bucket",
    //     svgName: "manageBucketIcon",
    //     route: "/dashboard/manageBucket",
    //     color: "#fad11d"
    // },
    updateMetaConfig: {
        label: "Update MetaConfig",
        description: "Create/Update meta configuration parameters",
        svgName: "Variable",
        route: "/dashboard/updateMetaConfig",
        color: "#52b894"
    },
    // manageOrder: {
    //     label: "Manage Order",
    //     description: "Lorem ipsum dolor sit amet, consectetur",
    //     svgName: "PJPVisitPlan",
    //     route: "/dashboard/manageOrder",
    //     color: "#fad11d"
    // },
    categoryDashboard: {
        label: "Category Reports",
        description: "View and Download Category based Reports",
        svgName: "manageBannerIcon",
        route: "/dashboard/categoryDashboard",
        color: "#0ABBD5"
    },
    brandDashboard: {
        label: "Brand Reports",
        description: "View and Download Brand based Reports",
        svgName: "manageBannerIcon",
        route: "/dashboard/brandDashboard",
        color: "#0ABBD5"
    },
    firebaseConfig: {
        label: "Firebase Configuration",
        description: "Configure Firebase services",
        svgName: "firebaseConfigIcon",
        route: "/dashboard/firebaseConfig",
        color: "#df263d"
    },
    // manageHomeScreen: {
    //     label: "Manage Home Screen",
    //     description: "Lorem ipsum dolor sit amet, consectetur",
    //     svgName: "ProductDetails",
    //     route: "/dashboard/manageHomeScreen",
    //     color: "#0ABBD5"
    // },
    couponManagement: {
        label: "Coupon Management",
        description: "Create and Manage Coupons",
        svgName: "PJPVisitPlan",
        route: "/couponDashboard/livecouponData",
        color: "#fad11d"
        
    },
    managePolicies: {
        label: "Manage Policies",
        description: "Create/Update terms and conditions and privacy Policy",
        svgName: "managePoliciesIcon",
        route: "/dashboard/managePolicies",
        color: "#fad11d"
    },
    updateTranslation:{
        label : "Update Translation",
        description:"Create, Update Delete and manage the bucket",
        svgName: "updateTranslationIcon",
        route: "/dashboard/updateTranslation",
        color: "#df263d"
    },
    manageRegistry: {
        label: "Manage Registry",
        description: "Lorem ipsum dolor sit amet, consectetur",
        svgName: "Variable",
        route: "/dashboard/manageRegistry",
        color: "#0ABBD5"
    },
    manageUpdateAccess: {
        label: "Manage Update Access",
        description: "Create/Delete Admin users",
        svgName: "manageUpdateAccessIcon",
        route: "/dashboard/manageUpdateAccess",
        color: "#df263d"
    },
    existingOutletApproval: {
        label: "Existing Outlet Approval",
        description: "Existing Outlet Approval",
        svgName: "manageUpdateAccessIcon",
        route: "/dashboard/outletMapping",
        color: "#df263d"
    },
    outletApproval: {
        label: "New Outlet Approval",
        description: "New Outlet Approval",
        svgName: "manageUpdateAccessIcon",
        route: "/dashboard/outletApproval",
        color: "#df263d"
    },
    uiConfig: {
        label: "uiConfig",
        description: "uiConfig",
        svgName: "manageUpdateAccessIcon",
        route: "/dashboard/uiConfigDashboard",
        color: "#df263d"
    },
    manageSSO: {
        label: "Manage SSO",
        description: "Manage SAML , API , OAUTH2",
        svgName: "manageBannerIcon",
        route: "/dashboard/manageSSO",
        color: "#0ABBD5"
    },
    manageRole: {
          label: "Manage Role",
          description: "Create and Edit Role Access",
          route: "/dashboard/manageRole",
          color: "#fad11d",
          svgName: "manageRoleIcon",
    },
    deliveryDateCalender: {
        label: "Delivery Date Calender",
        description: "Delivery Date Calender",
        svgName: "manageUpdateAccessIcon",
        route: "/dashboard/deliveryDateCalender",
        color: "#df263d"
    },
    manageDisplayCapture: {
        label: "Manage Display Capture",
        description: "Manage Display Capture",
        svgName: "manageUpdateAccessIcon",
        route: "/dashboard/manageDisplayCapture",
        color: "#df263d"
    },
    jobConfiguration: {
        label: "Job Configuration",
        description: "Job Configuration",
        svgName: "manageBannerIcon",
        route: "/dashboard/jobsConfiguration",
        color: "#0ABBD5"
    },
    incentive : {
        label: "Manage Incentive",
        description: "Incentive Dashboard",
        svgName: "incentive_icon",
        route: "/dashboard/incentiveDashboard",
        color: "#0ABBD5"
    },
    triggerNotification: {
        label: "Trigger Notification",
        description: "Create Trigger Notification",
        svgName: "notificationsIcon",
        route: "/dashboard/triggerNotification",
        color: "#fad11d"
    },
    updateGeofence: {
        label: "Update Geofence",
        description: "Update Geofence",
        svgName: "manageBannerIcon",
        route: "/dashboard/updateGeofence",
        color: "#0ABBD5"},
    manageRateMaster: {
        label: "Rate Master Approval",
        description: "Manage Rate Master",
        svgName: "manageUpdateAccessIcon",
        route: "/dashboard/manageRateMaster",
        color: "#df263d"
    },
    // dataValidation: {
    //     label: "Data Validation",
    //       description: "Get data for all entities",
    //       route: "/dashboard/dataValidation",
    //       color: "#fad11d",
    //       svgName: "manageRoleIcon",
    // }
    manageFeedbacks: {
        label: "Manage Feedbacks",
        description: "Manage Feedbacks",
        svgName: "manageFeedbacksIcon",
        route: "/dashboard/manageFeedbacks",
        color: "#F6760EFF"
    },
    pjpApproval: {
        label: "PJP Approval",
        description: "PJP Approval",
        svgName: "PJPVisitPlan",
        route: "/dashboard/pjpApproval",
        color: "#0ABBD5"
    },
    deviationApproval: {
        label: "Deviation Approval",
        description: "Deviation Approval",
        svgName: "PJPVisitPlan",
        route: "/dashboard/deviationApproval",
        color: "#52b894"
    },
    attendanceCorrection: {
        label: "Attendance Correction",
        description: "Attendance Correction",
        svgName: "manageBannerIcon",
        route: "/dashboard/attendanceCorrection",
        color: "#0ABBD5"
    },
    deletePJP: {
        label: "Delete PJP",
        description: "Delete PJP",
        svgName: "PJPVisitPlan",
        route: "/dashboard/deletePJP",
        color: "#FA5F1DFF"
    },
    moveToProduction: {
        label: "Move to Production",
        description: "Move all your configs and data to production",
        svgName: "Variable",
        route: "/dashboard/newConfig",
        color: "#52b894",
        disableNavigation: true
    }
    ,
    mdmSetUp: {
        label: "Mdm SetUp",
        description: "MDM Setup",
        svgName: "manageFeedbacksIcon",
        route: "/dashboard/mdmSetUp",
        color: "#F6760EFF"
    },
    reportsSetup: {
        label: "Reports Setup",
        description: "Reports Setup",
        svgName: "reportsIcon",
        route: "/dashboard/reportsSetup",
        color: "#0ABBD5"
    },
    deleteUserPJP: {
        label: "Delete User PJP",
        description: "Delete User PJP",
        svgName: "PJPVisitPlan",
        route: "/dashboard/deleteUserPJP",
        color: "#FA5F1DFF"
    },
    loyaltyManagement: {
        label: "Loyalty Management",
        description: "Loyalty Management",
        svgName: "PJPVisitPlan",
        route: "/dashboard/loyaltyManagement",
        color: "#8c4c09"
    },
    editConfiguration: {
        label: "Edit Configuration",
        description: "Edit Configuration",
        svgName: "editConfigurationIcon",
        route: "/dashboard/editConfiguration",
        color: "#FA1DFAFF"
    }
    // dataValidation: {
    //     label: "Data Validation",
    //       description: "Get data for all entities",
    //       route: "/dashboard/dataValidation",
    //       color: "#fad11d",
    //       svgName: "manageRoleIcon",
    // }
}

function AdminPanel() {
  const [adminPanelOptions,setAdminPanelOptions] = useState<adminPanelConfigOptionType[]>([]);
  const [showLoader,setShowLoader] = useState<boolean>(false);
  const [openProductionMovementPopup, setOpenProductionMovementPopup] = useState<boolean>(false);
  const {translate} =usePortalTranslation();
  useEffect(() => {
    async function mergeAndSetAdminPanelOptions(){
        setShowLoader(true);
        // const portalRoleConfig = await getPortalRoleConfig();
        const portalRoleConfig: featureType[] = [];
        // if(portalRoleConfig.length>0){
        //     const availableAdminPanelOptions = portalRoleConfig.filter((option: featureType) => {
        //         return option.template === "adminPanel";
        //     })
        //     const adminPanelOptions = convertToAdminPanelOptions(availableAdminPanelOptions);
        //     setAdminPanelOptions(adminPanelOptions);
        // }else{
            // let adminPanelOptionsConfig = await getAdminPanelOptionsConfig();
            let adminPanelOptionsConfig = store.getState()?.portalConfigState?.layoutConfig?.find((configObj) => configObj.name === "adminPanelLayout")?.value ?? [];
            // if(adminPanelOptionsConfig.length === 0){
            //     adminPanelOptionsConfig = Object.keys(adminPanelOptionConfigRegistry).map(key=>{
            //         return {id:key}
            //     })
            // }
            const mergedAdminPanelOptions = adminPanelOptionsConfig.map((option: {id: string} ) => {
                const id = option.id;
                const optionRegistyConfigs = adminPanelOptionConfigRegistry[id] || {}
                return {
                    ...optionRegistyConfigs,
                    ...option
                }
            });

            const portalConfig = await getMetaDataConfig(
                "clientconfig",
                "portal_configuration"
            );

            const moveToProductionIndex = mergedAdminPanelOptions.findIndex((value) => value.id === "moveToProduction");

            if (portalConfig && 
                isStandardLob(portalConfig) && 
                !(isProductionMovementCompleted(portalConfig)) && 
                showProductionMovementOption()) {
                if (moveToProductionIndex === -1) {
                    mergedAdminPanelOptions.push({
                        id: "moveToProduction",
                        ...adminPanelOptionConfigRegistry.moveToProduction,
                    });
                }
            } else {
                if (moveToProductionIndex !== -1) {
                    mergedAdminPanelOptions.splice(moveToProductionIndex, 1);
                }
            }

            logEvent(eventEnum.admin_panel,{feature_name:"admin_panel",dashboard_name:"admin_panel"});
            setAdminPanelOptions(mergedAdminPanelOptions);
            setShowLoader(false);
       
    }
    mergeAndSetAdminPanelOptions()
  },[])
  const navigate = useNavigate();
  return (
    <>
        <div className='adminPanelOptionsContainer'>
        <Typography className='adminPanelOptionsHeading' variant='h4'>{translate(TranslationEnum.admin_panel,"ADMIN PANEL")}</Typography>
            <div className='adminPanelCardsContainer'>
                {showLoader? <Loader /> : 
                // adminPanelOptions.map((option: adminPanelConfigOptionType,index: number) => {
                //     return <div key={index} className='adminPanelOptionCard' onClick={async () => { 
                //         if (option.id === "moveToProduction") {
                //             setOpenProductionMovementPopup(true);
                //         }
                //         if (option.id === "mdmSetUp") {
                //             setMdmCurrentStep(1);
                //         }
                //         if (!option.disableNavigation) {
                //             navigate(option.route || '/dashboard/adminPanel');
                //         }
                //     }}>
                //         <div className='adminPanelOptionCardHeader'>
                //             <Typography className='adminPanelCardHeading' variant='h5'>{translate(TranslationEnum.admin_panel,option.label)}</Typography>
                //             <div className='adminPanelOptionCardIconContainer' style={{ backgroundColor: option.color}}>
                //                 <div className='adminPanelOptionCardIcon'>
                //                     <RenderSvg name={option.svgName} />
                //                 </div>
                //             </div>
                //         </div>
                //         <Typography className="adminPanelCardDescription" variant='subtitle2'>{translate(TranslationEnum.admin_panel,option.description)}</Typography>
                //     </div>
                // })
                adminPanelOptions.map((option: adminPanelConfigOptionType, index: number) => {
                    const handleOptionClick = async () => {
                      if (option.id === "moveToProduction") {
                        setOpenProductionMovementPopup(true);
                      }
                      if (option.id === "mdmSetUp") {
                        setMdmCurrentStep(1);
                      }
                      if (!option.disableNavigation) {
                        navigate(option.route || '/dashboard/adminPanel');
                      }
                    };
                  
                    return (
                      <div
                        key={index}
                        className='adminPanelOptionCard'
                        role="button"
                        tabIndex={0}
                        aria-label={`${option.label} - ${option.description}`}
                        onClick={handleOptionClick}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleOptionClick();
                          }
                        }}
                      >
                        <div className='adminPanelOptionCardHeader'>
                          <Typography className='adminPanelCardHeading' variant='h5'>
                            {translate(TranslationEnum.admin_panel, option.label)}
                          </Typography>
                          <div
                            className='adminPanelOptionCardIconContainer'
                            style={{ backgroundColor: option.color }}
                          >
                            <div className='adminPanelOptionCardIcon'>
                              <RenderSvg name={option.svgName} />
                            </div>
                          </div>
                        </div>
                        <Typography className="adminPanelCardDescription" variant='subtitle2'>
                          {translate(TranslationEnum.admin_panel, option.description)}
                        </Typography>
                      </div>
                    );
                  })}
            </div>
        </div>
        <ProductionMovementConfirmationPopup open={openProductionMovementPopup} setOpen={setOpenProductionMovementPopup} />
    </>
  )
}

export default AdminPanel;